import type { SettlementRepository } from '../repository/SettlementRepository';
import type { TransactionSearchRequest, TransactionSearchResponse } from '../entity/SettlementTypes';

export class SearchTransactionsUseCase {
  constructor(private readonly repository: SettlementRepository) {}

  async execute(request: TransactionSearchRequest): Promise<TransactionSearchResponse> {
    if (!request.params || request.params.length === 0) {
      throw new Error('검색 파라미터가 필요합니다.');
    }
    return this.repository.searchTransactions(request);
  }
}
